import { render, staticRenderFns } from "./jumbo-widget.vue?vue&type=template&id=cf4eeb9c&scoped=true&"
import script from "./jumbo-widget.vue?vue&type=script&lang=js&"
export * from "./jumbo-widget.vue?vue&type=script&lang=js&"
import style0 from "./jumbo-widget.vue?vue&type=style&index=0&id=cf4eeb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4eeb9c",
  null
  
)

export default component.exports